goog.provide('yext.m4.confcode.adminconsole.ConfirmationModalController');

goog.require('yext.m4.confcode.adminconsole.confirmationmodal.template');
goog.require('yext.soy');

/**
 * Modal component for loading confirmations before applying
 */
yext.m4.confcode.adminconsole.ConfirmationModalController = class {
  /**
   * @param {!jQuery} $container - The jQuery element to mount the modal to
   * @param {!string} environment - The environment - prod, qa, sbx, dev
   */
  constructor($container, environment) {
    this._$container = $container;
    this._environment = environment;
  }

  /**
   * @public
   * Displays apply confirmation modal, binds event listeners for confirming apply and emits confirm-apply event if the user hits confirm.
   *
   * @param {!number} businessId - The ID of the business to confirm
   * @param {!string} businessName - The name of the business to confirm
   * @param {boolean} hasDependencyFile - whether there is a dependency file
   * @param {!string} missingDependencyBehavior - How to handle missing dependencies
   * @param {boolean} isDry - Whether the apply is a dry run
   * @param {boolean} isComprehensive - Whether the apply is comprehensive
   */
  open(
    businessId,
    businessName,
    hasDependencyFile,
    missingDependencyBehavior,
    isDry,
    isComprehensive) {
    const $modal = yext.soy.render(
      yext.m4.confcode.adminconsole.confirmationmodal.template.main,
      {
        environment: this._environment,
        businessName,
        businessId,
        hasDependencyFile,
        missingDependencyBehavior,
        isDry,
        isComprehensive,
      },
    );
    this._$container.html($modal);
    this._bindConfirmationSubmitHandler();
    this._toggleDisplay();
  }

  /**
   * @private
   * Bind confirmation handler
   */
  _bindConfirmationSubmitHandler() {
    // trigger another event when the user hits confirm
    this._$container.find('form').on('submit', e => {
      e.preventDefault();
      this._toggleDisplay();
      $(this).trigger('confirmApply');
    });
  }

  /**
   * @private
   * Toggles the display of the apply confirmation modal.
   */
  _toggleDisplay() {
    // TODO (varun): need to figure out how to use the boostrap modal method directly, instead of using a button.
    this._$container.find('.js-confirmation-modal-toggle').click();
  }
};
